<!--
 * @Author: your name
 * @Date: 2020-10-21 11:35:43
 * @LastEditTime: 2020-10-30 18:35:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \writing_pc\src\components\writing\note.vue
-->
<!-- 笔记 -->
<template>
<div class="note">
    <div class="note_c_box">
        <button class="close" @click="close()"><img src="/static/images/content_chacha_default.png" alt="" srcset=""></button>
        <h1>笔记</h1>
        <div class="inputbox">
            <textarea style="border: none;width:100%" type="text" name="" v-model="noteVal" maxlength="500" placeholder="添加笔记,不超过500字..." id="" @focus="showTag = true" />
            <div v-if="showTag">
                <div class="tag_box">
                    <el-input class="input-new-tag" placeholder="输入标签名" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm"></el-input>
                    <!-- <template v-if="taglist.length<20">
                        <button v-if="!inputVisible" class="button-new-tag" size="small" @click="showInput">+ 新增</button>
                    </template> -->
                </div>
                <!-- <div class="tag_box">
                    <div style="display: flex;flex-wrap: wrap;">
                        <span style="margin-right:10px">使用过的标签</span>
                        <template v-for="(item, index) in taglist">
                            <button v-show="index<looknum||nolook" :title="item.content" :class="labelList.indexOf(item.id)!=-1?'yes':''" :key="index" @click="addtag(item)">
                                <span class="tagname"> {{ item.content }}</span> <span class="xclose" @click.stop="deleteTag">

                                </span>
                            </button>

                        </template>

                        <span style="float:right; cursor: pointer;" v-if="nolook" @click="nolook=false">收起</span>
                    </div>
                    <div>

                    </div>
                    <span style="float:right; cursor: pointer;" v-if="!nolook" @click="nolook=true&&taglist.length>3">更多</span>
                </div> -->

                <div class="submit">
                    <button class="ok" @click="add_note">完成</button> <button class="no" @click="showTag=false">取消</button>
                </div>
            </div>
        </div>
        <div></div>

        <h2><span>所有笔记</span> <button class="clear" @click="noteClear">清空</button></h2>
        <div class="list_box">
            <div class="list_row" v-for="(item, index) in listData" :key="index" @click="look_note">
                <p v-if="item_input!=index" @click="pushitem(index)">{{ item.content }}</p>
                <textarea style="border: none;width:100%;height: 100px;" type="text" name="" v-model="item_noteVal" maxlength="500" placeholder="修改笔记,不超过500字..." v-if="item_input==index" />
                <div class="submit" v-if="item_input==index">
                    <button class="ok" @click="noteUpdate">完成</button> <button class="no" @click="item_input=-1">取消</button>
                </div>
                <div class="tag_btns">
                    <div style=" flex-wrap: nowrap; display: flex;">
                        <span class="tag" v-for="(items,i) in item.labels" :key="i">{{items.content}}</span>

                    </div>
                    <div style=" flex-wrap: nowrap; display: flex;">
                        <button class="look" v-if="item.docId" @click="lookpage(item)" title="查看全文"></button>
                        <button class="copy" @click="copyToClipBoard(item.content)" title="复制"></button>
                        <button class="export" @click="addhtml(item.content)" title="导入文中"></button>
                        <button class="delete" @click="noteDelete(item)" title="删除"></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="flooter" v-if="listData.length>0">
            <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange" :total="total"></el-pagination>
        </div>
    </div>

</div>
</template>

<script>
export default {
    data: function () {
        return {
            showTag: false,
            noteVal: "",
            taglist: [],
            dynamicTags: ['标签一', '标签二', '标签三'],
            inputVisible: false,
            inputValue: '',
            looknum: 3,
            pages: {
                current: 1,
                size: 10
            },
            nolook: false,
            total: 10,
            listData: [],
            item_input: -1,
            labelList: [],
            item_noteVal: ""
        };
    },
    components: {},
    mounted: function () {
        if (!this.$root.stateType.isLogin) {
            return false
        }
        this.initData()
        this.get_labelList()
    },
    methods: {
        /**
         * 清空笔记
         */
        noteClear: function () {
            this.api.noteClear().then(res => {
                if (res.code == 0) {
                    this.initData()
                }
            })
        },
        /**
         * 修改笔记
         */
        pushitem(index) {
            this.item_input == index ? this.item_input = -1 : this.item_input = index

            this.item_noteVal = this.listData[index].content
        },
        noteUpdate() {
            let data = {
                content: this.item_noteVal,
                id: this.listData[this.item_input].id,
                labelIds: []
            }
            this.api.noteUpdate(data).then(res => {
                this.initData()
                this.item_input = -1
            })
        },
        /**
         * 删除标签
         */
        deleteTag: function (item) {},
        addhtml: function (data) {
            this.$emit('addhtml', data)
        },
        /**
         * 删除笔记
         */
        noteDelete(item) {
            //使用form-data格式传参
            var formData = new FormData();
            formData.append("noteId", item.id);
            this.api.noteDelete(formData).then(res => {
                this.$message({
                    message: "删除成功",
                    type: "success"
                })
                this.initData()
            })
        },
        /**
         * 复制
         */
        copyToClipBoard: function (val) {
            var save = function (e) {
                e.clipboardData.setData("text/plain", val);
                e.preventDefault();
            };
            document.addEventListener("copy", save);
            document.execCommand("copy");
            document.removeEventListener("copy", save);
            let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 复制成功</div>`;
            this.$message({
                dangerouslyUseHTMLString: true,
                iconClass: "none",
                showClose: true,
                message: mgs,
                customClass: "mymessage",
                duration: 1000
            });
        },
        /**
         * 添加笔记
         */
        add_note: function () {
            if (this.noteVal.length == 0) {
                return false
            }
            this.api.addnote({
                "content": this.noteVal,
                "docId": "",
                "labelIds": this.labelList
            }).then(res => {
                console.log(res)
                if (res.code == 0) {
                    let mgs = `<div style="display: flex; align-items: center;"><img src="/static/images/gou.png" style="margin-right:5px;width:14px;height:14px" alt="" srcset="" /> 添加成功</div>`
                    this.$message({
                        dangerouslyUseHTMLString: true,
                        iconClass: 'none',
                        showClose: true,
                        message: mgs,
                        customClass: 'mymessage',
                        duration: 1000
                    });
                    this.noteVal = ""
                    this.labelList = []
                    this.initData()
                }
            })
        },
        look_note: function () {},
        addtag: function (item) {

            if (this.labelList.indexOf(item.id) == -1) {
                if (this.labelList.length === 3) {
                    this.labelList.splice(0, 1)
                }
                this.labelList.push(item.id)
            } else {
                let index = this.labelList.indexOf(item.id)
                this.labelList.splice(this.labelList.indexOf(item.id), 1)
            }

        },
        get_labelList: function () {
            this.api.labelList().then(res => {
                this.taglist = res.data
            })
        },
        close: function () {
            this.$emit('close_note', false)
        },
        /**
         * 查兰笔记来源
         */
        lookpage: function (item) {
            this.$emit('opendata', item.docId)

        },
        handleCurrentChange: function (val) {
            this.pages.current = val
            this.initData()
        },
        initData: function () {
            this.api.noteList(this.pages).then(res => {
                this.listData = res.data.records
                this.total = res.data.total
            })
        },

        showInput: function () {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleInputConfirm: function () {
            let inputValue = this.inputValue;
            if (inputValue) {
                let data = {
                    content: inputValue
                }
                this.api.labelAdd(inputValue).then(res => {
                    if (res.code == 0) {
                        this.get_labelList()
                    }
                })
            }
            this.inputVisible = false;
            this.inputValue = '';
        }
    }
};
</script>

<style lang="scss" scoped>
.note {
    height: calc(100vh - 105px);
    background: #ffffff;
    margin-top: 48px;
    box-shadow: 0px 0px 8px 0px rgba(51, 51, 57, 0.1);

    position: relative;
    z-index: 3;

    .note_c_box {
        height: calc(100vh - 105px);
        width: 400px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    .yes {

        background: #5576BD !important;
        color: #ffffff !important;
    }

    .close {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 10px;
        top: 20px;
        background: none;
        border: none;
    }

    .showLook {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    h1 {
        text-align: center;
        margin-top: 32px;
        font-size: 16px;
        font-weight: bold;
        color: #333339;
    }

    .inputbox {
        margin-left: 30px;
        margin-top: 24px;
        border: 1px solid #ededed;
        border-radius: 4px;
        padding: 16px 10px;
        width: calc(100% - 80px);

        input {
            border: none;
            width: 100%;
        }

        .title {
            color: #65676d;
            margin-top: 15px;
        }

        .tag_box {
            color: #979da1;
            margin-top: 23px;
            display: flex;
            justify-content: space-between;

            span {
                white-space: nowrap;
            }

            button {
                height: 20px;
                max-width: 70px;
                background: #e7efff;
                border-radius: 10px;
                font-size: 12px;
                color: #5575bd;
                border: none;
                margin-right: 8px;
                margin-bottom: 8px;
                display: flex;
                align-items: center;
            }

            .tagname {
                max-width: 40px;
                font-size: 12px;
                display: initial;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .xclose {
                font-size: 12px;
                margin-top: 2px;
                display: initial;
            }
        }

    }

    .submit {
        text-align: center;

    }

    .ok {
        color: #ffffff;
        width: 52px;
        height: 26px;
        background: linear-gradient(0deg, #5576bd 0%, #7294de 100%);
        border-radius: 13px;
        margin-right: 12px;
        border: none;
    }

    .no {
        width: 52px;
        color: #979da1;
        height: 26px;
        border: 1px solid #979da1;
        border-radius: 13px;
        margin-top: 25px;
    }

    h2 {
        margin: 23px 30px 12px;
        display: flex;
        justify-content: space-between;

        span {

            font-size: 14px;
            font-weight: 400;
            color: #65676D;
        }

        .clear {
            border: none;
            color: #979da1;
            background: none;
        }
    }

    .list_box {
        width: calc(100% - 60px);
        margin-left: 30px;
        height: 100%;
        padding-right: 30px;
        overflow: auto;

        .list_row {
            border: 1px solid #ededed;
            border-radius: 4px;
            padding: 16px 10px;
            margin-bottom: 12px;

            p {
                color: #65676d;
                word-break: break-word;
            }

            .tag_btns {
                display: flex;
                justify-content: space-between;
                margin-top: 16px;
                align-items: center;

                button {
                    border: none;
                    width: 16px;
                    height: 12px;
                    margin-left: 16px;
                }

                .tag {
                    padding: 3px 7px;
                    font-size: 12px;
                    color: #979DA1;
                    background: #F5F5F9;
                    border-radius: 10px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    max-width: 50px;
                }

                .tag+.tag {
                    margin-left: 5px;
                }

                .look {
                    background: url("/static/images/notes_eye_default.png") no-repeat;
                }

                .look:hover {
                    background: url("/static/images/notes_eye_hover.png") no-repeat;
                }

                .copy {
                    background: url("/static/images/notes_copy_default.png") no-repeat;
                    height: 15px;
                }

                .copy:hover {
                    background: url("/static/images/notes_copy_hover.png") no-repeat;
                }

                .export {
                    background: url("/static/images/notes_insert_default.png") no-repeat;
                    height: 15px;
                }

                .export:hover {
                    background: url("/static/images/notes_insert_hover.png") no-repeat;
                }

                .delete {
                    background: url("/static/images/notes_delete_default.png") no-repeat;
                    height: 16px;
                }

                .delete:hover {
                    background: url("/static/images/notes_delete_hover.png") no-repeat;
                }
            }
        }
    }

    .flooter {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/writing/note.vue